import {defineMessages} from 'react-intl';

export default defineMessages({
    description: {
        id: 'app.resetPassword.unknownError.description',
        defaultMessage: 'An unknown error occurred. Please contact us at mail@alvalabs.io'
    }
});
